export const MAP_PRODUCT_TABS = [
  'explore',
  'well_finder',
  'siteid',
  'padrekko',
  'helios',
  'purchase',
];

export function isMapProductTab(tab) {
  return MAP_PRODUCT_TABS.includes(tab)
}